export const illustrationKeys = {
  all: ['books'] as const,
  lists: () => [...illustrationKeys.all, 'list'] as const,
  list: (familyId: string, filters?: { onlyFavorites?: boolean }) =>
    filters?.onlyFavorites
      ? [...illustrationKeys.lists(), familyId, 'favorites'] as const
      : [...illustrationKeys.lists(), familyId] as const,
  details: () => [...illustrationKeys.all, 'detail'] as const,
  detail: (bookId: string) => [...illustrationKeys.details(), bookId] as const,
  pagePrompt: (bookId: string, pageNumber: number) =>
    [...illustrationKeys.all, 'pagePrompt', bookId, pageNumber] as const,
  videoStatus: (jobId: string) =>
    [...illustrationKeys.all, 'videoStatus', jobId] as const,
  byStory: (storyId: string) => [...illustrationKeys.all, 'byStory', storyId] as const,
};
